export const normalizeInvoiceValue = (type, value = "") =>
  type === "carrier" ? value.trim().toUpperCase() : value.trim();

export const isLoveCodeValid = (value = "") =>
  /^[0-9]{3,7}$/.test(value.trim());

export const formatLoveCodeLabel = (code, names) => {
  const name = names?.[code]?.trim();
  return name ? `${name}（${code}）` : code;
};

export const isInvoiceDestinationValid = (type, value = "") => {
  const normalized = normalizeInvoiceValue(type, value);
  return type === "carrier"
    ? /^\/[0-9A-Z.+-]{7}$/.test(normalized)
    : type === "love_code" && isLoveCodeValid(normalized);
};
